//
// Copyright 2020 The Yorkie Authors. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.10.1 with parameter "target=ts,import_extension=none"
// @generated from file yorkie/v1/yorkie.proto (package yorkie.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ChangePack, ChannelEvent, DocEvent, RevisionSummary, Rule } from "./resources_pb";
import { file_yorkie_v1_resources } from "./resources_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yorkie/v1/yorkie.proto.
 */
export const file_yorkie_v1_yorkie: GenFile = /*@__PURE__*/
  fileDesc("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", [file_yorkie_v1_resources]);

/**
 * @generated from message yorkie.v1.ActivateClientRequest
 */
export type ActivateClientRequest = Message<"yorkie.v1.ActivateClientRequest"> & {
  /**
   * @generated from field: string client_key = 1;
   */
  clientKey: string;

  /**
   * @generated from field: map<string, string> metadata = 2;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message yorkie.v1.ActivateClientRequest.
 * Use `create(ActivateClientRequestSchema)` to create a new message.
 */
export const ActivateClientRequestSchema: GenMessage<ActivateClientRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 0);

/**
 * @generated from message yorkie.v1.ActivateClientResponse
 */
export type ActivateClientResponse = Message<"yorkie.v1.ActivateClientResponse"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * actor_id is the stable actor derived from the project and client key.
   * Opted-in SDKs stamp it into changes; old SDKs ignore it and keep using
   * client_id as their actor.
   *
   * @generated from field: string actor_id = 2;
   */
  actorId: string;
};

/**
 * Describes the message yorkie.v1.ActivateClientResponse.
 * Use `create(ActivateClientResponseSchema)` to create a new message.
 */
export const ActivateClientResponseSchema: GenMessage<ActivateClientResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 1);

/**
 * @generated from message yorkie.v1.DeactivateClientRequest
 */
export type DeactivateClientRequest = Message<"yorkie.v1.DeactivateClientRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: bool synchronous = 2;
   */
  synchronous: boolean;
};

/**
 * Describes the message yorkie.v1.DeactivateClientRequest.
 * Use `create(DeactivateClientRequestSchema)` to create a new message.
 */
export const DeactivateClientRequestSchema: GenMessage<DeactivateClientRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 2);

/**
 * @generated from message yorkie.v1.DeactivateClientResponse
 */
export type DeactivateClientResponse = Message<"yorkie.v1.DeactivateClientResponse"> & {
};

/**
 * Describes the message yorkie.v1.DeactivateClientResponse.
 * Use `create(DeactivateClientResponseSchema)` to create a new message.
 */
export const DeactivateClientResponseSchema: GenMessage<DeactivateClientResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 3);

/**
 * @generated from message yorkie.v1.AttachDocumentRequest
 */
export type AttachDocumentRequest = Message<"yorkie.v1.AttachDocumentRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: yorkie.v1.ChangePack change_pack = 2;
   */
  changePack?: ChangePack;

  /**
   * @generated from field: string schema_key = 3;
   */
  schemaKey: string;

  /**
   * disable_gc declares that this attachment will not produce or consume
   * tombstones. The server skips minVV tracking and omits the response
   * VersionVector for this client. Use only with Counter / primitive
   * workloads; misuse leads to undefined GC behavior on this client.
   *
   * @generated from field: bool disable_gc = 4;
   */
  disableGc: boolean;

  /**
   * disable_presence declares that this document does not produce, consume,
   * or store presence. Honored on first attach only; subsequent attaches
   * observe the value persisted in the server-side document metadata. See
   * docs/tasks/active/20260616-presenceless-document-option-todo.md.
   *
   * @generated from field: bool disable_presence = 5;
   */
  disablePresence: boolean;
};

/**
 * Describes the message yorkie.v1.AttachDocumentRequest.
 * Use `create(AttachDocumentRequestSchema)` to create a new message.
 */
export const AttachDocumentRequestSchema: GenMessage<AttachDocumentRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 4);

/**
 * @generated from message yorkie.v1.AttachDocumentResponse
 */
export type AttachDocumentResponse = Message<"yorkie.v1.AttachDocumentResponse"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: yorkie.v1.ChangePack change_pack = 2;
   */
  changePack?: ChangePack;

  /**
   * @generated from field: int32 max_size_per_document = 3;
   */
  maxSizePerDocument: number;

  /**
   * @generated from field: repeated yorkie.v1.Rule schema_rules = 4;
   */
  schemaRules: Rule[];

  /**
   * disable_presence carries the server-fixated value of the document's
   * presence option (see AttachDocumentRequest.disable_presence). Clients
   * align their local gating state to this value rather than the requested
   * value, so an attach to an already-fixated document observes the
   * persisted decision.
   *
   * @generated from field: bool disable_presence = 5;
   */
  disablePresence: boolean;
};

/**
 * Describes the message yorkie.v1.AttachDocumentResponse.
 * Use `create(AttachDocumentResponseSchema)` to create a new message.
 */
export const AttachDocumentResponseSchema: GenMessage<AttachDocumentResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 5);

/**
 * @generated from message yorkie.v1.DetachDocumentRequest
 */
export type DetachDocumentRequest = Message<"yorkie.v1.DetachDocumentRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: yorkie.v1.ChangePack change_pack = 3;
   */
  changePack?: ChangePack;

  /**
   * @generated from field: bool remove_if_not_attached = 4;
   */
  removeIfNotAttached: boolean;
};

/**
 * Describes the message yorkie.v1.DetachDocumentRequest.
 * Use `create(DetachDocumentRequestSchema)` to create a new message.
 */
export const DetachDocumentRequestSchema: GenMessage<DetachDocumentRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 6);

/**
 * @generated from message yorkie.v1.DetachDocumentResponse
 */
export type DetachDocumentResponse = Message<"yorkie.v1.DetachDocumentResponse"> & {
  /**
   * @generated from field: yorkie.v1.ChangePack change_pack = 2;
   */
  changePack?: ChangePack;
};

/**
 * Describes the message yorkie.v1.DetachDocumentResponse.
 * Use `create(DetachDocumentResponseSchema)` to create a new message.
 */
export const DetachDocumentResponseSchema: GenMessage<DetachDocumentResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 7);

/**
 * @generated from message yorkie.v1.WatchRequest
 */
export type WatchRequest = Message<"yorkie.v1.WatchRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * resources lists what the stream delivers. It must hold between 1 and 100
   * descriptors, and the server must recognize every one of them: a request
   * naming a resource the server cannot subscribe to is rejected whole rather
   * than served in part, so a client never watches fewer resources than it
   * asked for without being told.
   *
   * @generated from field: repeated yorkie.v1.ResourceDescriptor resources = 2;
   */
  resources: ResourceDescriptor[];

  /**
   * actor_id is the stable actor the client stamps into its changes. When set,
   * the server subscribes the client under it so watch peer ids and
   * watched/unwatched events match the presence CRDT keying. Old SDKs omit it
   * and the server falls back to client_id (the session id).
   *
   * @generated from field: string actor_id = 3;
   */
  actorId: string;
};

/**
 * Describes the message yorkie.v1.WatchRequest.
 * Use `create(WatchRequestSchema)` to create a new message.
 */
export const WatchRequestSchema: GenMessage<WatchRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 8);

/**
 * @generated from message yorkie.v1.ResourceDescriptor
 */
export type ResourceDescriptor = Message<"yorkie.v1.ResourceDescriptor"> & {
  /**
   * @generated from oneof yorkie.v1.ResourceDescriptor.resource
   */
  resource: {
    /**
     * @generated from field: yorkie.v1.DocumentDescriptor document = 1;
     */
    value: DocumentDescriptor;
    case: "document";
  } | {
    /**
     * @generated from field: yorkie.v1.ChannelDescriptor channel = 2;
     */
    value: ChannelDescriptor;
    case: "channel";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yorkie.v1.ResourceDescriptor.
 * Use `create(ResourceDescriptorSchema)` to create a new message.
 */
export const ResourceDescriptorSchema: GenMessage<ResourceDescriptor> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 9);

/**
 * @generated from message yorkie.v1.DocumentDescriptor
 */
export type DocumentDescriptor = Message<"yorkie.v1.DocumentDescriptor"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message yorkie.v1.DocumentDescriptor.
 * Use `create(DocumentDescriptorSchema)` to create a new message.
 */
export const DocumentDescriptorSchema: GenMessage<DocumentDescriptor> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 10);

/**
 * @generated from message yorkie.v1.ChannelDescriptor
 */
export type ChannelDescriptor = Message<"yorkie.v1.ChannelDescriptor"> & {
  /**
   * @generated from field: string channel_key = 1;
   */
  channelKey: string;
};

/**
 * Describes the message yorkie.v1.ChannelDescriptor.
 * Use `create(ChannelDescriptorSchema)` to create a new message.
 */
export const ChannelDescriptorSchema: GenMessage<ChannelDescriptor> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 11);

/**
 * @generated from message yorkie.v1.WatchResponse
 */
export type WatchResponse = Message<"yorkie.v1.WatchResponse"> & {
  /**
   * @generated from oneof yorkie.v1.WatchResponse.body
   */
  body: {
    /**
     * @generated from field: yorkie.v1.WatchInitialization initialization = 1;
     */
    value: WatchInitialization;
    case: "initialization";
  } | {
    /**
     * @generated from field: yorkie.v1.WatchEvent event = 2;
     */
    value: WatchEvent;
    case: "event";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yorkie.v1.WatchResponse.
 * Use `create(WatchResponseSchema)` to create a new message.
 */
export const WatchResponseSchema: GenMessage<WatchResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 12);

/**
 * @generated from message yorkie.v1.WatchInitialization
 */
export type WatchInitialization = Message<"yorkie.v1.WatchInitialization"> & {
  /**
   * @generated from field: repeated yorkie.v1.ResourceInit resource_inits = 1;
   */
  resourceInits: ResourceInit[];
};

/**
 * Describes the message yorkie.v1.WatchInitialization.
 * Use `create(WatchInitializationSchema)` to create a new message.
 */
export const WatchInitializationSchema: GenMessage<WatchInitialization> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 13);

/**
 * @generated from message yorkie.v1.ResourceInit
 */
export type ResourceInit = Message<"yorkie.v1.ResourceInit"> & {
  /**
   * @generated from oneof yorkie.v1.ResourceInit.init
   */
  init: {
    /**
     * @generated from field: yorkie.v1.DocumentInit document_init = 1;
     */
    value: DocumentInit;
    case: "documentInit";
  } | {
    /**
     * @generated from field: yorkie.v1.ChannelInit channel_init = 2;
     */
    value: ChannelInit;
    case: "channelInit";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yorkie.v1.ResourceInit.
 * Use `create(ResourceInitSchema)` to create a new message.
 */
export const ResourceInitSchema: GenMessage<ResourceInit> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 14);

/**
 * @generated from message yorkie.v1.DocumentInit
 */
export type DocumentInit = Message<"yorkie.v1.DocumentInit"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: repeated string client_ids = 2;
   */
  clientIds: string[];
};

/**
 * Describes the message yorkie.v1.DocumentInit.
 * Use `create(DocumentInitSchema)` to create a new message.
 */
export const DocumentInitSchema: GenMessage<DocumentInit> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 15);

/**
 * @generated from message yorkie.v1.ChannelInit
 */
export type ChannelInit = Message<"yorkie.v1.ChannelInit"> & {
  /**
   * @generated from field: string channel_key = 1;
   */
  channelKey: string;

  /**
   * @generated from field: int64 session_count = 2;
   */
  sessionCount: bigint;

  /**
   * @generated from field: int64 seq = 3;
   */
  seq: bigint;
};

/**
 * Describes the message yorkie.v1.ChannelInit.
 * Use `create(ChannelInitSchema)` to create a new message.
 */
export const ChannelInitSchema: GenMessage<ChannelInit> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 16);

/**
 * @generated from message yorkie.v1.WatchEvent
 */
export type WatchEvent = Message<"yorkie.v1.WatchEvent"> & {
  /**
   * @generated from oneof yorkie.v1.WatchEvent.event
   */
  event: {
    /**
     * @generated from field: yorkie.v1.DocWatchEvent doc_event = 1;
     */
    value: DocWatchEvent;
    case: "docEvent";
  } | {
    /**
     * @generated from field: yorkie.v1.ChannelWatchEvent channel_event = 2;
     */
    value: ChannelWatchEvent;
    case: "channelEvent";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yorkie.v1.WatchEvent.
 * Use `create(WatchEventSchema)` to create a new message.
 */
export const WatchEventSchema: GenMessage<WatchEvent> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 17);

/**
 * @generated from message yorkie.v1.DocWatchEvent
 */
export type DocWatchEvent = Message<"yorkie.v1.DocWatchEvent"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: yorkie.v1.DocEvent event = 2;
   */
  event?: DocEvent;
};

/**
 * Describes the message yorkie.v1.DocWatchEvent.
 * Use `create(DocWatchEventSchema)` to create a new message.
 */
export const DocWatchEventSchema: GenMessage<DocWatchEvent> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 18);

/**
 * @generated from message yorkie.v1.ChannelWatchEvent
 */
export type ChannelWatchEvent = Message<"yorkie.v1.ChannelWatchEvent"> & {
  /**
   * @generated from field: string channel_key = 1;
   */
  channelKey: string;

  /**
   * @generated from field: yorkie.v1.ChannelEvent event = 2;
   */
  event?: ChannelEvent;
};

/**
 * Describes the message yorkie.v1.ChannelWatchEvent.
 * Use `create(ChannelWatchEventSchema)` to create a new message.
 */
export const ChannelWatchEventSchema: GenMessage<ChannelWatchEvent> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 19);

/**
 * Deprecated: Use WatchRequest instead.
 *
 * @generated from message yorkie.v1.WatchDocumentRequest
 */
export type WatchDocumentRequest = Message<"yorkie.v1.WatchDocumentRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;
};

/**
 * Describes the message yorkie.v1.WatchDocumentRequest.
 * Use `create(WatchDocumentRequestSchema)` to create a new message.
 */
export const WatchDocumentRequestSchema: GenMessage<WatchDocumentRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 20);

/**
 * Deprecated: Use WatchResponse instead.
 *
 * @generated from message yorkie.v1.WatchDocumentResponse
 */
export type WatchDocumentResponse = Message<"yorkie.v1.WatchDocumentResponse"> & {
  /**
   * @generated from oneof yorkie.v1.WatchDocumentResponse.body
   */
  body: {
    /**
     * @generated from field: yorkie.v1.WatchDocumentResponse.Initialization initialization = 1;
     */
    value: WatchDocumentResponse_Initialization;
    case: "initialization";
  } | {
    /**
     * @generated from field: yorkie.v1.DocEvent event = 2;
     */
    value: DocEvent;
    case: "event";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yorkie.v1.WatchDocumentResponse.
 * Use `create(WatchDocumentResponseSchema)` to create a new message.
 */
export const WatchDocumentResponseSchema: GenMessage<WatchDocumentResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 21);

/**
 * @generated from message yorkie.v1.WatchDocumentResponse.Initialization
 */
export type WatchDocumentResponse_Initialization = Message<"yorkie.v1.WatchDocumentResponse.Initialization"> & {
  /**
   * @generated from field: repeated string client_ids = 1;
   */
  clientIds: string[];
};

/**
 * Describes the message yorkie.v1.WatchDocumentResponse.Initialization.
 * Use `create(WatchDocumentResponse_InitializationSchema)` to create a new message.
 */
export const WatchDocumentResponse_InitializationSchema: GenMessage<WatchDocumentResponse_Initialization> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 21, 0);

/**
 * Deprecated: Use WatchRequest instead.
 *
 * @generated from message yorkie.v1.WatchChannelRequest
 */
export type WatchChannelRequest = Message<"yorkie.v1.WatchChannelRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string channel_key = 2;
   */
  channelKey: string;
};

/**
 * Describes the message yorkie.v1.WatchChannelRequest.
 * Use `create(WatchChannelRequestSchema)` to create a new message.
 */
export const WatchChannelRequestSchema: GenMessage<WatchChannelRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 22);

/**
 * Deprecated: Use WatchResponse instead.
 *
 * @generated from message yorkie.v1.WatchChannelResponse
 */
export type WatchChannelResponse = Message<"yorkie.v1.WatchChannelResponse"> & {
  /**
   * @generated from oneof yorkie.v1.WatchChannelResponse.body
   */
  body: {
    /**
     * @generated from field: yorkie.v1.WatchChannelInitialized initialized = 1;
     */
    value: WatchChannelInitialized;
    case: "initialized";
  } | {
    /**
     * @generated from field: yorkie.v1.ChannelEvent event = 2;
     */
    value: ChannelEvent;
    case: "event";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yorkie.v1.WatchChannelResponse.
 * Use `create(WatchChannelResponseSchema)` to create a new message.
 */
export const WatchChannelResponseSchema: GenMessage<WatchChannelResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 23);

/**
 * Deprecated: Use ChannelInit instead.
 *
 * @generated from message yorkie.v1.WatchChannelInitialized
 */
export type WatchChannelInitialized = Message<"yorkie.v1.WatchChannelInitialized"> & {
  /**
   * @generated from field: int64 session_count = 1;
   */
  sessionCount: bigint;

  /**
   * @generated from field: int64 seq = 2;
   */
  seq: bigint;
};

/**
 * Describes the message yorkie.v1.WatchChannelInitialized.
 * Use `create(WatchChannelInitializedSchema)` to create a new message.
 */
export const WatchChannelInitializedSchema: GenMessage<WatchChannelInitialized> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 24);

/**
 * @generated from message yorkie.v1.RemoveDocumentRequest
 */
export type RemoveDocumentRequest = Message<"yorkie.v1.RemoveDocumentRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: yorkie.v1.ChangePack change_pack = 3;
   */
  changePack?: ChangePack;
};

/**
 * Describes the message yorkie.v1.RemoveDocumentRequest.
 * Use `create(RemoveDocumentRequestSchema)` to create a new message.
 */
export const RemoveDocumentRequestSchema: GenMessage<RemoveDocumentRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 25);

/**
 * @generated from message yorkie.v1.RemoveDocumentResponse
 */
export type RemoveDocumentResponse = Message<"yorkie.v1.RemoveDocumentResponse"> & {
  /**
   * @generated from field: yorkie.v1.ChangePack change_pack = 1;
   */
  changePack?: ChangePack;
};

/**
 * Describes the message yorkie.v1.RemoveDocumentResponse.
 * Use `create(RemoveDocumentResponseSchema)` to create a new message.
 */
export const RemoveDocumentResponseSchema: GenMessage<RemoveDocumentResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 26);

/**
 * @generated from message yorkie.v1.PushPullChangesRequest
 */
export type PushPullChangesRequest = Message<"yorkie.v1.PushPullChangesRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: yorkie.v1.ChangePack change_pack = 3;
   */
  changePack?: ChangePack;

  /**
   * @generated from field: bool push_only = 4;
   */
  pushOnly: boolean;

  /**
   * disable_gc declares that this PushPull will not produce or consume
   * tombstones. The server skips minVV tracking and omits the response
   * VersionVector. Clients that attached with disable_gc=true must keep
   * setting this on every subsequent PushPullChanges. See
   * docs/design/disable-gc-on-attach.md.
   *
   * @generated from field: bool disable_gc = 5;
   */
  disableGc: boolean;
};

/**
 * Describes the message yorkie.v1.PushPullChangesRequest.
 * Use `create(PushPullChangesRequestSchema)` to create a new message.
 */
export const PushPullChangesRequestSchema: GenMessage<PushPullChangesRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 27);

/**
 * @generated from message yorkie.v1.PushPullChangesResponse
 */
export type PushPullChangesResponse = Message<"yorkie.v1.PushPullChangesResponse"> & {
  /**
   * @generated from field: yorkie.v1.ChangePack change_pack = 1;
   */
  changePack?: ChangePack;
};

/**
 * Describes the message yorkie.v1.PushPullChangesResponse.
 * Use `create(PushPullChangesResponseSchema)` to create a new message.
 */
export const PushPullChangesResponseSchema: GenMessage<PushPullChangesResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 28);

/**
 * @generated from message yorkie.v1.CreateRevisionRequest
 */
export type CreateRevisionRequest = Message<"yorkie.v1.CreateRevisionRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;
};

/**
 * Describes the message yorkie.v1.CreateRevisionRequest.
 * Use `create(CreateRevisionRequestSchema)` to create a new message.
 */
export const CreateRevisionRequestSchema: GenMessage<CreateRevisionRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 29);

/**
 * @generated from message yorkie.v1.CreateRevisionResponse
 */
export type CreateRevisionResponse = Message<"yorkie.v1.CreateRevisionResponse"> & {
  /**
   * @generated from field: yorkie.v1.RevisionSummary revision = 1;
   */
  revision?: RevisionSummary;
};

/**
 * Describes the message yorkie.v1.CreateRevisionResponse.
 * Use `create(CreateRevisionResponseSchema)` to create a new message.
 */
export const CreateRevisionResponseSchema: GenMessage<CreateRevisionResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 30);

/**
 * @generated from message yorkie.v1.GetRevisionRequest
 */
export type GetRevisionRequest = Message<"yorkie.v1.GetRevisionRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: string revision_id = 3;
   */
  revisionId: string;
};

/**
 * Describes the message yorkie.v1.GetRevisionRequest.
 * Use `create(GetRevisionRequestSchema)` to create a new message.
 */
export const GetRevisionRequestSchema: GenMessage<GetRevisionRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 31);

/**
 * @generated from message yorkie.v1.GetRevisionResponse
 */
export type GetRevisionResponse = Message<"yorkie.v1.GetRevisionResponse"> & {
  /**
   * @generated from field: yorkie.v1.RevisionSummary revision = 1;
   */
  revision?: RevisionSummary;
};

/**
 * Describes the message yorkie.v1.GetRevisionResponse.
 * Use `create(GetRevisionResponseSchema)` to create a new message.
 */
export const GetRevisionResponseSchema: GenMessage<GetRevisionResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 32);

/**
 * @generated from message yorkie.v1.ListRevisionsRequest
 */
export type ListRevisionsRequest = Message<"yorkie.v1.ListRevisionsRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;

  /**
   * @generated from field: bool is_forward = 5;
   */
  isForward: boolean;
};

/**
 * Describes the message yorkie.v1.ListRevisionsRequest.
 * Use `create(ListRevisionsRequestSchema)` to create a new message.
 */
export const ListRevisionsRequestSchema: GenMessage<ListRevisionsRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 33);

/**
 * @generated from message yorkie.v1.ListRevisionsResponse
 */
export type ListRevisionsResponse = Message<"yorkie.v1.ListRevisionsResponse"> & {
  /**
   * @generated from field: repeated yorkie.v1.RevisionSummary revisions = 1;
   */
  revisions: RevisionSummary[];
};

/**
 * Describes the message yorkie.v1.ListRevisionsResponse.
 * Use `create(ListRevisionsResponseSchema)` to create a new message.
 */
export const ListRevisionsResponseSchema: GenMessage<ListRevisionsResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 34);

/**
 * @generated from message yorkie.v1.RestoreRevisionRequest
 */
export type RestoreRevisionRequest = Message<"yorkie.v1.RestoreRevisionRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: string revision_id = 4;
   */
  revisionId: string;
};

/**
 * Describes the message yorkie.v1.RestoreRevisionRequest.
 * Use `create(RestoreRevisionRequestSchema)` to create a new message.
 */
export const RestoreRevisionRequestSchema: GenMessage<RestoreRevisionRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 35);

/**
 * @generated from message yorkie.v1.RestoreRevisionResponse
 */
export type RestoreRevisionResponse = Message<"yorkie.v1.RestoreRevisionResponse"> & {
};

/**
 * Describes the message yorkie.v1.RestoreRevisionResponse.
 * Use `create(RestoreRevisionResponseSchema)` to create a new message.
 */
export const RestoreRevisionResponseSchema: GenMessage<RestoreRevisionResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 36);

/**
 * @generated from message yorkie.v1.AttachChannelRequest
 */
export type AttachChannelRequest = Message<"yorkie.v1.AttachChannelRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string channel_key = 2;
   */
  channelKey: string;
};

/**
 * Describes the message yorkie.v1.AttachChannelRequest.
 * Use `create(AttachChannelRequestSchema)` to create a new message.
 */
export const AttachChannelRequestSchema: GenMessage<AttachChannelRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 37);

/**
 * @generated from message yorkie.v1.AttachChannelResponse
 */
export type AttachChannelResponse = Message<"yorkie.v1.AttachChannelResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: int64 session_count = 2;
   */
  sessionCount: bigint;
};

/**
 * Describes the message yorkie.v1.AttachChannelResponse.
 * Use `create(AttachChannelResponseSchema)` to create a new message.
 */
export const AttachChannelResponseSchema: GenMessage<AttachChannelResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 38);

/**
 * @generated from message yorkie.v1.DetachChannelRequest
 */
export type DetachChannelRequest = Message<"yorkie.v1.DetachChannelRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string channel_key = 2;
   */
  channelKey: string;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId: string;
};

/**
 * Describes the message yorkie.v1.DetachChannelRequest.
 * Use `create(DetachChannelRequestSchema)` to create a new message.
 */
export const DetachChannelRequestSchema: GenMessage<DetachChannelRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 39);

/**
 * @generated from message yorkie.v1.DetachChannelResponse
 */
export type DetachChannelResponse = Message<"yorkie.v1.DetachChannelResponse"> & {
  /**
   * @generated from field: int64 session_count = 1;
   */
  sessionCount: bigint;
};

/**
 * Describes the message yorkie.v1.DetachChannelResponse.
 * Use `create(DetachChannelResponseSchema)` to create a new message.
 */
export const DetachChannelResponseSchema: GenMessage<DetachChannelResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 40);

/**
 * @generated from message yorkie.v1.RefreshChannelRequest
 */
export type RefreshChannelRequest = Message<"yorkie.v1.RefreshChannelRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string channel_key = 2;
   */
  channelKey: string;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * client_key and metadata are used only on the first call (when session_id
   * is empty). The server activates the client and attaches it to the channel
   * before refreshing, collapsing ActivateClient + AttachChannel + RefreshChannel
   * into a single round trip.
   *
   * @generated from field: string client_key = 4;
   */
  clientKey: string;

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message yorkie.v1.RefreshChannelRequest.
 * Use `create(RefreshChannelRequestSchema)` to create a new message.
 */
export const RefreshChannelRequestSchema: GenMessage<RefreshChannelRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 41);

/**
 * @generated from message yorkie.v1.RefreshChannelResponse
 */
export type RefreshChannelResponse = Message<"yorkie.v1.RefreshChannelResponse"> & {
  /**
   * @generated from field: int64 session_count = 1;
   */
  sessionCount: bigint;

  /**
   * client_id and session_id are populated only when the request was a
   * first-call (i.e. session_id was empty). Subsequent heartbeats leave
   * these empty.
   *
   * @generated from field: string client_id = 2;
   */
  clientId: string;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId: string;
};

/**
 * Describes the message yorkie.v1.RefreshChannelResponse.
 * Use `create(RefreshChannelResponseSchema)` to create a new message.
 */
export const RefreshChannelResponseSchema: GenMessage<RefreshChannelResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 42);

/**
 * PeekChannel reads the current session_count of a channel without creating
 * a session on the server. Use this when a client only needs to display the
 * count (e.g. "N people writing") without contributing to it and without
 * receiving broadcasts. Caller polls on its own cadence.
 *
 * @generated from message yorkie.v1.PeekChannelRequest
 */
export type PeekChannelRequest = Message<"yorkie.v1.PeekChannelRequest"> & {
  /**
   * @generated from field: string channel_key = 1;
   */
  channelKey: string;
};

/**
 * Describes the message yorkie.v1.PeekChannelRequest.
 * Use `create(PeekChannelRequestSchema)` to create a new message.
 */
export const PeekChannelRequestSchema: GenMessage<PeekChannelRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 43);

/**
 * @generated from message yorkie.v1.PeekChannelResponse
 */
export type PeekChannelResponse = Message<"yorkie.v1.PeekChannelResponse"> & {
  /**
   * @generated from field: int64 session_count = 1;
   */
  sessionCount: bigint;
};

/**
 * Describes the message yorkie.v1.PeekChannelResponse.
 * Use `create(PeekChannelResponseSchema)` to create a new message.
 */
export const PeekChannelResponseSchema: GenMessage<PeekChannelResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 44);

/**
 * @generated from message yorkie.v1.BroadcastRequest
 */
export type BroadcastRequest = Message<"yorkie.v1.BroadcastRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string channel_key = 2;
   */
  channelKey: string;

  /**
   * @generated from field: string topic = 3;
   */
  topic: string;

  /**
   * @generated from field: bytes payload = 4;
   */
  payload: Uint8Array;
};

/**
 * Describes the message yorkie.v1.BroadcastRequest.
 * Use `create(BroadcastRequestSchema)` to create a new message.
 */
export const BroadcastRequestSchema: GenMessage<BroadcastRequest> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 45);

/**
 * @generated from message yorkie.v1.BroadcastResponse
 */
export type BroadcastResponse = Message<"yorkie.v1.BroadcastResponse"> & {
};

/**
 * Describes the message yorkie.v1.BroadcastResponse.
 * Use `create(BroadcastResponseSchema)` to create a new message.
 */
export const BroadcastResponseSchema: GenMessage<BroadcastResponse> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_yorkie, 46);

/**
 * Yorkie is a service that provides an API for SDKs.
 *
 * @generated from service yorkie.v1.YorkieService
 */
export const YorkieService: GenService<{
  /**
   * @generated from rpc yorkie.v1.YorkieService.ActivateClient
   */
  activateClient: {
    methodKind: "unary";
    input: typeof ActivateClientRequestSchema;
    output: typeof ActivateClientResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.DeactivateClient
   */
  deactivateClient: {
    methodKind: "unary";
    input: typeof DeactivateClientRequestSchema;
    output: typeof DeactivateClientResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.AttachDocument
   */
  attachDocument: {
    methodKind: "unary";
    input: typeof AttachDocumentRequestSchema;
    output: typeof AttachDocumentResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.DetachDocument
   */
  detachDocument: {
    methodKind: "unary";
    input: typeof DetachDocumentRequestSchema;
    output: typeof DetachDocumentResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.RemoveDocument
   */
  removeDocument: {
    methodKind: "unary";
    input: typeof RemoveDocumentRequestSchema;
    output: typeof RemoveDocumentResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.PushPullChanges
   */
  pushPullChanges: {
    methodKind: "unary";
    input: typeof PushPullChangesRequestSchema;
    output: typeof PushPullChangesResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.Watch
   */
  watch: {
    methodKind: "server_streaming";
    input: typeof WatchRequestSchema;
    output: typeof WatchResponseSchema;
  },
  /**
   * Deprecated: Use Watch with ResourceDescriptor instead.
   *
   * @generated from rpc yorkie.v1.YorkieService.WatchDocument
   */
  watchDocument: {
    methodKind: "server_streaming";
    input: typeof WatchDocumentRequestSchema;
    output: typeof WatchDocumentResponseSchema;
  },
  /**
   * Deprecated: Use Watch with ResourceDescriptor instead.
   *
   * @generated from rpc yorkie.v1.YorkieService.WatchChannel
   */
  watchChannel: {
    methodKind: "server_streaming";
    input: typeof WatchChannelRequestSchema;
    output: typeof WatchChannelResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.CreateRevision
   */
  createRevision: {
    methodKind: "unary";
    input: typeof CreateRevisionRequestSchema;
    output: typeof CreateRevisionResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.GetRevision
   */
  getRevision: {
    methodKind: "unary";
    input: typeof GetRevisionRequestSchema;
    output: typeof GetRevisionResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.ListRevisions
   */
  listRevisions: {
    methodKind: "unary";
    input: typeof ListRevisionsRequestSchema;
    output: typeof ListRevisionsResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.RestoreRevision
   */
  restoreRevision: {
    methodKind: "unary";
    input: typeof RestoreRevisionRequestSchema;
    output: typeof RestoreRevisionResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.AttachChannel
   */
  attachChannel: {
    methodKind: "unary";
    input: typeof AttachChannelRequestSchema;
    output: typeof AttachChannelResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.DetachChannel
   */
  detachChannel: {
    methodKind: "unary";
    input: typeof DetachChannelRequestSchema;
    output: typeof DetachChannelResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.RefreshChannel
   */
  refreshChannel: {
    methodKind: "unary";
    input: typeof RefreshChannelRequestSchema;
    output: typeof RefreshChannelResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.PeekChannel
   */
  peekChannel: {
    methodKind: "unary";
    input: typeof PeekChannelRequestSchema;
    output: typeof PeekChannelResponseSchema;
  },
  /**
   * @generated from rpc yorkie.v1.YorkieService.Broadcast
   */
  broadcast: {
    methodKind: "unary";
    input: typeof BroadcastRequestSchema;
    output: typeof BroadcastResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yorkie_v1_yorkie, 0);

